import React, {useRef, useState} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router-dom";

import {getCurrentUserRole, getCurrentUserRoutes} from "../../../slices/UserSlice";
import {ROLES} from "../../../utilities/generalConstants.js/generalConstants";

const NavItem = props => {
  const {dataName, name, children, multiUser} = props;
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  const location = useLocation();
  const pathName = location.pathname;
  const isCurrentLocation = pathName.includes(dataName);

  const navPath = dataName.replace("ba3a/", "");
  const allowedRoutes = useSelector(getCurrentUserRoutes);
  const role = useSelector(getCurrentUserRole) || null;
  const isSuperUser = role === ROLES.SUPER_USER;

  const ifAllowed = allowedRoutes?.filter(route => route.routeUrl.includes(navPath));
  if (!isSuperUser && !multiUser && ifAllowed?.length < 1) {
    return null;
  }
  // const ifBos = ifAllowed?.some(route => route.routeUrl.includes("bos"));
  const visibleSubRoutes = children;

  // ifBos
  // ? children
  // : React.Children.map(children, child => {
  //     if (child.props?.to?.includes("bos")) {
  //       return null;
  //     } else return child;
  //   });

  const notAvailableStyle = {
    color: "#527eab",
    fontWeight: 400,
  };

  const currentStyle = props?.notAvailableStyle ? notAvailableStyle : {};

  return (
    <li>
      <div
        ref={buttonRef}
        style={{border: "none", backgroundColor: "transparent"}}
        className={`nav-item ${isCurrentLocation ? "bold" : ""}`}
        onClick={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onKeyDown={e => {
          if (e.key === "Escape") {
            setOpen(false);
            return;
          }
          if (e.currentTarget === e.target) {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setOpen(true);
            }
          }
        }}
        onBlur={e => {
          if (buttonRef.current && buttonRef.current.contains(e.relatedTarget)) {
            return;
          }
          setOpen(false);
        }}
        aria-haspopup="true"
        aria-expanded={!!open}
        role="button"
        tabIndex={0}
      >
        <span
          className="navTitle"
          style={{
            ...currentStyle,
            ...(props.uppercase ? {textTransform: "uppercase"} : {}),
            ...(props.icon ? {paddingTop: "4px"} : {}),
          }}
        >
          {props.icon && props.icon}
          {name}
        </span>
        {open && (
          <span
            className="dropdown"
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") {
                setTimeout(() => setOpen(false), 200);
              }
            }}
            onClick={() => {
              setTimeout(() => setOpen(false), 0);
            }}
          >
            {visibleSubRoutes}
          </span>
        )}
      </div>
    </li>
  );
};

export default NavItem;
